import { render, staticRenderFns } from "./Industrial.vue?vue&type=template&id=477827fe"
import script from "./Industrial.vue?vue&type=script&lang=ts"
export * from "./Industrial.vue?vue&type=script&lang=ts"
import style0 from "./Industrial.vue?vue&type=style&index=0&id=477827fe&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports